import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

interface ITeamcenterWorkflowResponse {
  uuid: string;
}

@Injectable({
  providedIn: 'root',
})
export class TeamcenterService {
  public constructor(private readonly http: HttpClient) {}

  public startSync(designId: string) {
    const workflowName = 'LE4_CALL_REFRESH_SAP';

    return this.http
      .post<ITeamcenterWorkflowResponse>(
        `${environment.teamcenter}/async/${workflowName}/PD${designId}`,
        undefined
      )
      .pipe(map((response) => response.uuid));
  }

  public checkSyncStatus(uuid: string) {
    return this.http.get(`${environment.teamcenter}/async/${uuid}`);
  }
}
